
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="结合行展开表格" fileName="row-expand-table.md" />
        <demo-block>
        
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;div&gt;
        &lt;ve-table
            fixed-header
            :max-height=&quot;500&quot;
            :virtual-scroll-option=&quot;virtualScrollOption&quot;
            :expand-option=&quot;expandOption&quot;
            :columns=&quot;columns&quot;
            :table-data=&quot;tableData&quot;
            row-key-field-name=&quot;rowKey&quot;
        /&gt;
    &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
    // 此示例是在组件内部定义了一个子组件。你当然也可以通过 `import`关键字导入一个组件
    const ChildTableComp = {
        name: &quot;ChildTableComp&quot;,
        template: `
        &lt;div class=&quot;child-table-comp&quot;&gt;
            &lt;span style=&quot;font-weight:bold;&quot;&gt;Table Name:{{row.name}}&lt;/span&gt;
            &lt;ve-table
              :max-height=&quot;300&quot;
              :fixed-header=&quot;true&quot;
              style=&quot;width:100%&quot;
              :columns=&quot;columns&quot;
              :table-data=&quot;tableData&quot;
              :virtual-scroll-option=&quot;{
                  enable: false,
              }&quot;
            /&gt;
        &lt;/div&gt;
    `,
        props: {
            row: Object,
        },
        data() {
            return {
                columns: [
                    { field: &quot;col1&quot;, key: &quot;a&quot;, title: &quot;Col1&quot; },
                    { field: &quot;col2&quot;, key: &quot;b&quot;, title: &quot;Col2&quot; },
                    { field: &quot;col3&quot;, key: &quot;c&quot;, title: &quot;Col3&quot; },
                    { field: &quot;col4&quot;, key: &quot;d&quot;, title: &quot;Col4&quot; },
                    { field: &quot;col5&quot;, key: &quot;e&quot;, title: &quot;Col5&quot; },
                ],
                tableData: [
                    {
                        col1: &quot;1&quot;,
                        col2: &quot;2&quot;,
                        col3: &quot;3&quot;,
                        col4: &quot;4&quot;,
                        col5: &quot;5&quot;,
                    },
                    {
                        col1: &quot;1&quot;,
                        col2: &quot;2&quot;,
                        col3: &quot;3&quot;,
                        col4: &quot;4&quot;,
                        col5: &quot;5&quot;,
                    },
                    {
                        col1: &quot;1&quot;,
                        col2: &quot;2&quot;,
                        col3: &quot;3&quot;,
                        col4: &quot;4&quot;,
                        col5: &quot;5&quot;,
                    },
                    {
                        col1: &quot;1&quot;,
                        col2: &quot;2&quot;,
                        col3: &quot;3&quot;,
                        col4: &quot;4&quot;,
                        col5: &quot;5&quot;,
                    },
                ],
            };
        },
    };

    export default {
        data() {
            return {
                virtualScrollOption: {
                    // 是否开启
                    enable: true,
                },
                expandOption: {
                    defaultExpandedRowKeys: [2],
                    render: ({ row, column, rowIndex }, h) =&gt; {
                        return &lt;ChildTableComp row={row} /&gt;;
                    },
                },

                columns: [
                    {
                        field: &quot;&quot;,
                        key: &quot;a&quot;,
                        // type=expand
                        type: &quot;expand&quot;,
                        title: &quot;&quot;,
                        width: 50,
                        align: &quot;center&quot;,
                    },
                    {
                        field: &quot;name&quot;,
                        key: &quot;b&quot;,
                        title: &quot;Name&quot;,
                        width: 200,
                        align: &quot;left&quot;,
                        renderBodyCell: ({ row }, h) =&gt; {
                            return &lt;span domPropsInnerHTML={row.name}&gt;&lt;/span&gt;;
                        },
                    },
                    {
                        field: &quot;hobby&quot;,
                        key: &quot;c&quot;,
                        title: &quot;Hobby&quot;,
                        width: 300,
                        align: &quot;left&quot;,
                    },
                    {
                        field: &quot;address&quot;,
                        key: &quot;d&quot;,
                        title: &quot;Address&quot;,
                        width: &quot;&quot;,
                        align: &quot;left&quot;,
                    },
                ],
                tableData: [],
            };
        },
        methods: {
            initData() {
                let data = [];
                for (let i = 0; i &lt; 10000; i++) {
                    data.push({
                        rowKey: i,
                        name: `name${i}`,
                        hobby: `hobby${i}`,
                        address: `address${i}`,
                    });
                }

                this.tableData = data;
            },
        },
        created() {
            this.initData();
        },
    };
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('ve-table',{attrs:{"fixed-header":"","max-height":500,"virtual-scroll-option":_vm.virtualScrollOption,"expand-option":_vm.expandOption,"columns":_vm.columns,"table-data":_vm.tableData,"row-key-field-name":"rowKey"}})],1)]],2)}
var staticRenderFns = []

  
    // 此示例是在组件内部定义了一个子组件。你当然也可以通过 `import`关键字导入一个组件
    const ChildTableComp = {
        name: "ChildTableComp",
        template: `
        <div class="child-table-comp">
            <span style="font-weight:bold;">Table Name:{{row.name}}</span>
            <ve-table
              :max-height="300"
              :fixed-header="true"
              style="width:100%"
              :columns="columns"
              :table-data="tableData"
              :virtual-scroll-option="{
                  enable: false,
              }"
            />
        </div>
    `,
        props: {
            row: Object,
        },
        data() {
            return {
                columns: [
                    { field: "col1", key: "a", title: "Col1" },
                    { field: "col2", key: "b", title: "Col2" },
                    { field: "col3", key: "c", title: "Col3" },
                    { field: "col4", key: "d", title: "Col4" },
                    { field: "col5", key: "e", title: "Col5" },
                ],
                tableData: [
                    {
                        col1: "1",
                        col2: "2",
                        col3: "3",
                        col4: "4",
                        col5: "5",
                    },
                    {
                        col1: "1",
                        col2: "2",
                        col3: "3",
                        col4: "4",
                        col5: "5",
                    },
                    {
                        col1: "1",
                        col2: "2",
                        col3: "3",
                        col4: "4",
                        col5: "5",
                    },
                    {
                        col1: "1",
                        col2: "2",
                        col3: "3",
                        col4: "4",
                        col5: "5",
                    },
                ],
            };
        },
    };

    const democomponentExport = {
        data() {
            return {
                virtualScrollOption: {
                    // 是否开启
                    enable: true,
                },
                expandOption: {
                    defaultExpandedRowKeys: [2],
                    render: ({ row, column, rowIndex }, h) => {
                        return <ChildTableComp row={row} />;
                    },
                },

                columns: [
                    {
                        field: "",
                        key: "a",
                        // type=expand
                        type: "expand",
                        title: "",
                        width: 50,
                        align: "center",
                    },
                    {
                        field: "name",
                        key: "b",
                        title: "Name",
                        width: 200,
                        align: "left",
                        renderBodyCell: ({ row }, h) => {
                            return <span domPropsInnerHTML={row.name}></span>;
                        },
                    },
                    {
                        field: "hobby",
                        key: "c",
                        title: "Hobby",
                        width: 300,
                        align: "left",
                    },
                    {
                        field: "address",
                        key: "d",
                        title: "Address",
                        width: "",
                        align: "left",
                    },
                ],
                tableData: [],
            };
        },
        methods: {
            initData() {
                let data = [];
                for (let i = 0; i < 10000; i++) {
                    data.push({
                        rowKey: i,
                        name: `name${i}`,
                        hobby: `hobby${i}`,
                        address: `address${i}`,
                    });
                }

                this.tableData = data;
            },
        },
        created() {
            this.initData();
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      
    </style>
  